import {SUBJECTS_STATUS} from 'common/constants'
import {useEffect, useState} from 'react'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {Outlet, useLocation} from 'react-router'
import {toast} from 'react-toastify'
import {RootState, UserReducer} from 'setup'
import {attendanceSettingsByLevelIds} from 'setup/redux/Actions/Attendance/attendance'
import {getClasses} from 'setup/redux/Actions/Class/class'
import {getMappings} from 'setup/redux/Actions/CustomNames/customNames'
import {getGeneralSettings} from 'setup/redux/Actions/General/settings'
import {getLevels} from 'setup/redux/Actions/Level/level'
import {getLoggedInUserData} from 'setup/redux/Actions/SignIn/login'
import {getSubjects} from 'setup/redux/Actions/Subject/subject'

import {reInitMenu} from '../helpers'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Sidebar} from './components/sidebar'
import {ToolbarWrapper} from './components/toolbar'
import {PageDataProvider} from './core'

const MasterLayout = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  const userReducer: UserReducer = useSelector<RootState>(
    ({userReducer}) => userReducer,
    shallowEqual
  ) as UserReducer

  const accessToken: string = userReducer.accessToken as string

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (accessToken) {
      setLoading(true)
      const onSuccess = () => {
        setLoading(false)

        setTimeout(() => {
          reInitMenu()
        }, 500)
      }

      const onFailure = (err: any) => {
        const message =
          err?.response?.data?.message ??
          err?.response?.message ??
          err?.message ??
          'Invalid Auth Token'
        toast.error(message)
        setLoading(false)
      }

      dispatch(getLoggedInUserData(onSuccess, onFailure))
      dispatch(getGeneralSettings())
      dispatch(getClasses({}, null, null, true))
      dispatch(getMappings())
      dispatch(attendanceSettingsByLevelIds())
      dispatch(getSubjects({search: {status: SUBJECTS_STATUS.ACTIVE}}, null, null, true))
      dispatch(getLevels())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  if (loading) {
    return (
      <div id='splash-screen' className='splash-screen bg-body'>
        {/* <img src={toAbsoluteUrl('/media/logos/logo-1.svg')} alt='logo' className='h-30px' /> */}
        <div className='bs-spinner-grow' style={{width: '4rem', height: '4rem'}} role='status' />
        <div className='text-gray-800'>Loading ...</div>
      </div>
    )
  }

  return (
    <PageDataProvider>
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <ToolbarWrapper />
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}
      {/* <ActivityDrawer /> */}
      {/* <RightToolbar /> */}
      {/* <DrawerMessenger /> */}
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      {/* <InviteUsers /> */}
      {/* <UpgradePlan /> */}
      {/* end:: Modals */}

      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
